// extracted by mini-css-extract-plugin
export default {"batch":"batches_batch__uS4TA","view_schehule_":"batches_view_schehule___ZAnvG"};